export default {
    meta: {
        title: '项目管理',
        isShowNav: true,
    },
};
